import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { IDropdownHieararchy } from "../interfaces/idropdownconfig";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
/**
 * @whatItDoes A service for handling all country dashboard information
 *
 * @howToUse To use, inject in to any constructor
 */
export class DropdownHierarchyService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    getHierarchy(): Observable<IDropdownHieararchy> {
        return super.get("/api/dropdownhierarchy").pipe(map((r: any) => r as IDropdownHieararchy));
    }

    save(dropdownHiearchy: IDropdownHieararchy): Observable<IDropdownHieararchy> {
        return super.put("/api/dropdownhierarchy", dropdownHiearchy).pipe(map((r: any) => r as IDropdownHieararchy));
    }
}






